import { render, staticRenderFns } from "./manage-option-translation-modal.vue?vue&type=template&id=a9b1fcb2"
import script from "./manage-option-translation-modal.vue?vue&type=script&lang=js"
export * from "./manage-option-translation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports